import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class OpenNewIssueDialogCommand extends AbstractCommand<void> {

    public name: CommandName = CommandName.OPEN_NEW_ISSUE_DIALOG;

    public tags = ['ui', 'dialog', 'issue', 'create'];

    constructor() {
        super('issue', 'new', undefined);
    }
}